import { type IUploadDocument, isValidMimeType, uploadDocument } from "@api";
import type { IDocument } from "@bbj-types/document";
import { DocumentTypes } from "@bbj-types/document/enum";
import axios from "axios";

const preUpload = async (file: File) => {
  const mimeType = file.type;
  if (!isValidMimeType(mimeType)) {
    throw new Error("Invalid MIME Type");
  }
  const response = await uploadDocument(file.name, DocumentTypes.ATTACHMENT, mimeType, true);
  return { ...response.data, file };
};

const handlePreUpload = async (files: FileList) => {
  const errors: File[] = [];
  const success: (IUploadDocument & { file: File })[] = [];
  const promises: Promise<unknown>[] = [];
  for (const file of files) {
    promises.push(
      preUpload(file)
        .then((result) => success.push(result))
        .catch(() => errors.push(file))
    );
  }
  await Promise.allSettled(promises);
  return [success, errors] as const;
};

export const handleUpload = async (files: FileList) => {
  const [uploadsInfos, filesErrors] = await handlePreUpload(files);
  const documents: IDocument[] = [];
  const promises: Promise<unknown>[] = [];
  for (const uploadInfo of uploadsInfos) {
    promises.push(
      axios
        .postForm(uploadInfo.url, { ...uploadInfo.fields, file: uploadInfo.file })
        .then(() => documents.push(uploadInfo.document))
        .catch(() => filesErrors.push(uploadInfo.file))
    );
  }
  await Promise.allSettled(promises);
  return [documents, filesErrors] as const;
};
